import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Homepage from "./Pages/Homepage/Homepage";
import NavBarComponent from "./Components/NavBar/NavBar";
import Footer from "./Components/Footer/Footer";
import ContactUs from "./Pages/ContactUs/ContactUs";
import AboutDCM from "./Pages/AboutDCM/AboutDCM";
import Services from "./Pages/Services/Services";
import Products from "./Pages/Products/Products";
import TaxationCalendar from "./Pages/TaxationCalendar/TaxationCalendar";
import NotFound from "./Pages/NotFound/NotFound";
import ScrollToTop from '../src/Components/ScrollToTop';

let App = () => {
  return (
    <Router basename={"/"}>
      <ScrollToTop />
      <NavBarComponent />
      <Routes>
        <Route path="/" element={<Homepage />} />
        <Route path="/about-dcm" element={<AboutDCM />} />
        <Route path="/contact-us" element={<ContactUs />} />
        <Route path="/services" element={<Services />} />
        <Route path="/products" element={<Products />} />
        <Route path="/taxation-calendar" element={<TaxationCalendar />} />
        <Route path="*" element={<NotFound  />} />
      </Routes>
      <Footer />
    </Router>
  );
};

export default App;
